import styled from '@emotion/styled';
import { Button } from 'antd';

export const StyledButtonThick = styled(Button)``;
